
import {Vue, Component} from 'vue-property-decorator';
import {nil} from '@/common';
@Component({
    components: {
    },
})
export default class GlobalAlertMixin extends Vue {
    public showAlert(message: any, type: string = 'error', timeout: number = 3500) {
        let text = message;
        if (typeof message !== 'string' && !nil(message.message)) {
            text = message.message;
        }
        this.$bus.$emit('showAlert', {
            type,
            text,
            timeout,
        });
    }
}
